var navTrigger = $('#js-gnavTrigger'),
    navBody = $('#js-gnavBody'),
    logo = $('#js-logo'),
    gNavi = $('#js-gnavBody a');

if (!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {

  navTrigger.on('click', function() {
    $(this).toggleClass('is-active');
    navBody.add(logo).toggleClass('is-opened');
  });
  gNavi.on('click', function(){
    navTrigger.removeClass('is-active');
    navBody.add(logo).removeClass('is-opened');
  });

} else {

  navTrigger.on('touchstart', function() {
    $(this).toggleClass('is-active');
    navBody.add(logo).toggleClass('is-opened');
  });
  gNavi.on('click', function(){
    navTrigger.removeClass('is-active');
    navBody.add(logo).removeClass('is-opened');
  });

}


//////////////////
// WEBPACK FOOTER
// ./src/js/sp-navi.js
// module id = 12
// module chunks = 0